export const planBaseMaxAccounts = {
  "sked-fundamentals": 1,
  "sked-essentials": 3,
  "sked-professional": 6,
  "sked-enterprise": 20,
  "sked-enterprise-custom": 20,
} as const;
